<div class="upload_container mx-0">
    <ng-container *ngIf="display_event_data">
        <div class="grid event_details pt-3">
            <div class="col">
                <p>
                    Event Details<span class="error">*</span>
                </p>
                <form [formGroup]="event_details" class="grid pt-2 justify-items-space-between">
                    <div class="lg:col-3 md:col-3 sm:col-12 p-1">
                        <input pInputText formControlName="name" [size]="30" type="text" [required]="true"
                            class="p-inputtext" [style]="{'width':'100%'}" placeholder="Enter Event Name*" />
                        <div *ngIf="event_details.get('name')?.hasError('required') && event_details.get('name')?.touched"
                            class="error">
                            Event name is required.
                        </div>
                    </div>
                    <div class="lg:col-3 md:col-3 sm:col-12 p-1">
                        <p-dropdown styleClass="location-select" [required]="true" [options]="filtered_locations"
                            formControlName="location" placeholder="Select Location" [filter]="true" filterBy="name"
                            optionLabel="name"></p-dropdown>
                        <div *ngIf="event_details.get('location')?.hasError('required') && event_details.get('location')?.touched"
                            class="error">
                            Event location is required.
                        </div>
                    </div>
                    <div class="lg:col-3 md:col-3 sm:col-12 p-1">
                        <p-calendar [appendTo]="'body'" [required]="true" formControlName="time" [style]="{'width':'100%'}"
                            [inputStyle]="{'width':'100%'}" [showTime]="true" [showSeconds]="false" [hourFormat]="'12'"
                            [readonlyInput]="true" [maxDate]="maxAllowedDate"
                            placeholder="Select Date and Time of the Event*" dateFormat="dd MM yy" timeFormat="HH:mm"></p-calendar>
                        <div *ngIf="event_details.get('time')?.hasError('required') && event_details.get('time')?.touched"
                            class="error">
                            Event time is required.
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </ng-container>
    <div class="grid">
        <div class="lg:col-12 md:col-12 sm:col-12">
            <p class="pt-5 upload_header">
                Upload a file<span class="error" *ngIf="display_event_data">*</span>
            </p>
            <ul class="pt-2" *ngIf="display_event_data && !check_form_status()">
                <li>
                    1. Please make sure the file is in {{accepted_formats}} formats.
                </li>
                <li>
                    2. Please make sure the file doesn't contain any special characters.
                </li>
            </ul>
            <div class="ps-2 col error" *ngIf="check_form_status()">
                Please fill event details to upload a file
            </div>
            <div class="grid pt-4">
                
                <button [disabled]="check_form_status()" class="lg:col-3 md:col-3 sm:col-12 btn" [ngClass]="check_form_status() ?'disabled_div' :'btn-primary'" (click)="file_input.click()" id="upload_btn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 33 33" fill="none">
                        <line x1="5.42755" y1="27.6809" x2="28.8749" y2="27.6809" stroke="white"
                            stroke-width="2.38816" />
                        <line x1="28.7665" y1="18.2833" x2="28.7665" y2="27.6809" stroke="white" stroke-width="2.38816"
                            stroke-linecap="round" />
                        <line x1="5.31908" y1="18.2833" x2="5.31908" y2="27.6809" stroke="white" stroke-width="2.38816"
                            stroke-linecap="round" />
                        <path
                            d="M17.9956 3.28065C17.5293 2.81433 16.7733 2.81433 16.307 3.28065L8.70789 10.8797C8.24158 11.346 8.24158 12.1021 8.70789 12.5684C9.17421 13.0347 9.93026 13.0347 10.3966 12.5684L17.1513 5.81367L23.906 12.5684C24.3724 13.0347 25.1284 13.0347 25.5947 12.5684C26.061 12.1021 26.061 11.346 25.5947 10.8797L17.9956 3.28065ZM18.3454 21.8036V4.12499H15.9572L15.9572 21.8036H18.3454Z"
                            fill="white" />
                    </svg> Upload
                </button>
                
                <input type='file' #file_input hidden (change)="uploadFile($event)" [accept]="accepted_formats" />
                <div class="col" *ngIf="commonservice.selected_file!=undefined">
                    <div class="uploaded_file" *ngIf="filename!='' && db_store">
                        {{filename}} &nbsp; &nbsp; <span class="close_icon col-1"
                            (click)="commonservice.selected_file=undefined">
                        </span>
                    </div>
                    <div class="uploaded_file"  *ngIf="filename=='' && db_store && commonservice.selected_file">
                        {{get_name_from_url(commonservice.selected_file)}} &nbsp; &nbsp; <span class="close_icon col-1"
                            (click)="commonservice.selected_file=undefined">
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
